import { createLibraryLoggerProvider } from "librarylog";

export const devLogger = createLibraryLoggerProvider().getLogger().named("dev");
